import { CityStaffNoteRO } from '@routellers/types/dist/openapi/city-player/city-staff';

import { ApiMethodDeclaration } from '..';

export const staffNotes: ApiMethodDeclaration<
    { routeStopId?: number; attractionId?: number },
    CityStaffNoteRO[]
> = ({ routeStopId, attractionId }) => ({
    url: '/admins/staff-notes',
    method: 'GET',
    params: { routeStopId, attractionId },
});
